import styled from "styled-components";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const IgorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 200px;
    border-radius: 50%;
    border: 3px solid var(--bg-secondary);
  }
`;
export const TextIgorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  h1 {
    text-transform: uppercase;
    font-family: var(--font-workSans);
    font-size: 36px;
    font-weight: bold;
    line-height: 42px;
  }
`;
export const DevContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h2 {
    font-size: 34px;
    font-weight: bold;
    color: var(--color-yellow);
    font-family: var(--fong-raleway);

    -webkit-animation: text-focus-in 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) 5
      alternate both;
    animation: text-focus-in 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) 5
      alternate both;
  }
  @-webkit-keyframes text-focus-in {
    0% {
      -webkit-filter: blur(12px);
      filter: blur(12px);
      opacity: 0;
    }
    100% {
      -webkit-filter: blur(0px);
      filter: blur(0px);
      opacity: 1;
    }
  }
  @keyframes text-focus-in {
    0% {
      -webkit-filter: blur(12px);
      filter: blur(12px);
      opacity: 0;
    }
    100% {
      -webkit-filter: blur(0px);
      filter: blur(0px);
      opacity: 1;
    }
  }
`;
export const TechContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
    width: 60%;
  }

  img {
    width: 100%;
    max-width: 50px;
  }
`;
